export default {"src":"/_next/static/media/minusIcon.f70aacc6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};